import React from 'react';
import yamaha from '../images/marcas/yamaha.png';
import hidea from '../images/marcas/hidea.png';
import tohatsu from '../images/marcas/tohatsu.png';
import suzuki from '../images/marcas/suzuki.png';
import Je from '../images/marcas/Je.png';
import mercury from '../images/marcas/mercury.png';
import honda from '../images/marcas/honda.png';

const clientImage = {
    height: '8rem',
    width: 'auto',
    mixBlendMode: 'colorBurn'
}

const Clients = () => {
    return (
        <div className="pt-8 ">
            <section data-aos="fade-up">
                <div className="py-4">
                        <h2 className="py-2 text-center text-3xl text-blue-900 uppercase font-bold">Marcas que trabalhamos</h2>
                        <div className='flex justify-center'>
                            <div className='w-24 border-b-4 border-primary'></div>
                        </div>
                        <h2 className="mt-4 mx-12 text-center text-xl lg:text-2xl font-semibold text-blue-900">Trabalhamos com o que há de melhor no mercado.</h2>
                    </div>

                <div className="p-16" data-aos="fade-in" data-aos-delay="600">
                    <div className="grid sm:grid-cols-3 lg:grid-cols-4">
                        <div style={clientImage} className= "overflow-hidden flex justify-center transition-all ease-in-out w-1/6">
                            <img src={yamaha} alt="client" className='bg-white p-2' />                           
                        </div>

                        <div style={clientImage} className="overflow-hidden p-3 flex justify-center transition-all ease-in-out">
                            <img src={hidea} alt="client"  className='bg-white p-2'/>                            
                        </div> 

                        <div style={clientImage} className="overflow-hidden p-3 flex justify-center transition-all ease-in-out">
                            <img src={tohatsu} alt="client"  className='bg-white p-2'/>                            
                        </div>

                        <div style={clientImage} className="overflow-hidden p-3 flex justify-center transition-all ease-in-out">
                            <img src={suzuki} alt="client"  className='bg-white p-2'/>                            
                        </div>

                        <div style={clientImage} className="overflow-hidden p-3 flex justify-center transition-all ease-in-out">
                            <img src={Je} alt="client"  className='bg-white p-2'/>                            
                        </div>

                        <div style={clientImage} className="overflow-hidden p-3 flex justify-center transition-all ease-in-out">
                            <img src={mercury} alt="client"  className='bg-white p-2'/>                            
                        </div>

                        <div style={clientImage} className="overflow-hidden p-3 flex justify-center transition-all ease-in-out">
                            <img src={honda} alt="client"  className='bg-white p-2'/>                            
                        </div>
                                           
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Clients;